import { Schema, model } from 'mongoose';
import { paginate, toJSON } from '@/shared/utils/plugins';
import { IAmenities, IAmenitiesModel } from '../constructionStatus.interfaces';

const amenitiesSchema = new Schema<IAmenities>(
  {
    name: { type: String, required: true, trim: true },
    icon: { type: String, required: true },
    description: { type: String, default: '' },
    createdBy: { type: Schema.Types.ObjectId, ref: 'User' },
    updatedBy: { type: Schema.Types.ObjectId, ref: 'User' },
  },
  { timestamps: true },
);

amenitiesSchema.plugin(toJSON);
amenitiesSchema.plugin(paginate);

const Amenities = model<IAmenities, IAmenitiesModel>('Amenities', amenitiesSchema);
export default Amenities;
